module.exports = __webpack_public_path__ + "static/media/c2_levels_8-29.fea32094.png";